import { FC } from 'react';

import BaseCoatingListing from 'components/main/BaseCoating';

const BaseCoating: FC = () => <BaseCoatingListing />;

export default BaseCoating;
